// extracted by mini-css-extract-plugin
export var assigneeBadge = "_l2-0";
export var assigneeDetails = "_l2-1";
export var assigneeInfo = "_l2-2";
export var dropdownContainer = "_l2-4";
export var dropdownImage = "_l2-5";
export var editAssigneeInfo = "_l2-3";
export var editAssigneeModalContainer = "_l2-6";
export var hidden = "_l2-8";
export var input = "_l2-7";